import React from 'react';
import { ModalProps } from '@/hooks/useModal';
import { StepWhatHappensNext } from './StepWhatHappensNext';
import { StepWhereToFindThings } from './StepWhereToFindThings';
import { StepYoureAllSet } from './StepYoureAllSet';

const TOTAL_STEPS = 3;

interface Props {
	Modal: React.FC<ModalProps>;
	onClose: () => void;
	onFinish: () => void;
}

export const GuidedTourModal: React.FC<Props> = ({
	Modal,
	onClose,
	onFinish,
}) => {
	const [step, setStep] = React.useState(1);

	const handleClose = () => {
		setStep(1);
		onClose();
	};

	const handleNext = () => setStep((prev) => Math.min(prev + 1, TOTAL_STEPS));
	const handleBack = () => setStep((prev) => Math.max(prev - 1, 1));

	const handleFinish = () => {
		setStep(1);
		onFinish();
	};

	const stepProps = {
		onClose: handleClose,
		onNext: handleNext,
		onBack: handleBack,
		onFinish: handleFinish,
		currentStep: step,
		totalSteps: TOTAL_STEPS,
	};

	return (
		<Modal
			avoidClose
			classNameMainContainer="!p-0 md:!p-4"
			classNameCardContainer="!w-full !h-full md:!w-[720px] md:!max-w-[720px] md:!h-[768px] !p-0 !flex !flex-col !rounded-none md:!rounded-[32px] !shadow-[0px_14px_42px_0px_#080F340F] bg-white overflow-hidden"
			classNameContainerChildren="!max-h-none !flex-1 !flex !flex-col !min-h-0 !px-0 lg:!px-0"
			noMaxHeight
		>
			{step === 1 && <StepWhatHappensNext {...stepProps} />}
			{step === 2 && <StepWhereToFindThings {...stepProps} />}
			{step === 3 && <StepYoureAllSet {...stepProps} />}
		</Modal>
	);
};
